import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ApiServiceService } from 'src/app/services/api-service.service';

// import { UserDataService } from '../../services/user-data.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {


constructor(private router:Router ,public api:ApiServiceService){

}

scrollToTop(): void {
  window.scrollTo({ top: 0});
}

getCurrentUserId(): string {
  const token = localStorage.getItem('token');
  if (token) {
    try {
      const decodedToken = JSON.parse(atob(token.split('.')[1]));
      return decodedToken.id || '';
    } catch (e) {
      console.error('Error decoding token:', e);
    }
  }
  return '';
}

yourAccount() {
  if (this.getCurrentUserId()) {
    // User is logged in, navigate to profile-details
    this.router.navigate(['profile-details']);
  } else {
    // User is not logged in, navigate to login page
    this.router.navigate(['Signin', 0]);
  }
  window.scrollTo({ top: 0 }); // Scroll to the top of the page
}

helpCenter(){
if (this.getCurrentUserId()) {
  // User is logged in, navigate to profile-details
  this.router.navigate(["help-support"])
} else {
  // User is not logged in, navigate to login page
  this.router.navigate(['Signin', 0]);
}
window.scrollTo({ top: 0 }); // Scroll to the top of the page
}


errorPage(){
  this.router.navigate(['page-not-found'])
}
}
